"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckInModes = void 0;
const CheckInModes = {
    CheckInCheckOut: 'CheckInCheckOut',
    Standard: 'Standard',
};
exports.CheckInModes = CheckInModes;
